import { render, staticRenderFns } from "./ReportTypeSelect.vue?vue&type=template&id=810ef3c4&"
import script from "./ReportTypeSelect.vue?vue&type=script&lang=js&"
export * from "./ReportTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports